import { Drawer, Form, Radio, Input, Space, Button, Upload, message, Image, Typography } from 'antd';
import SiteModuleDrawerOperationLogExtra from '../SiteModuleDrawerOperationLogExtra';
import { fullWidthPageFormItemLayout } from '@utils/property';
import { useEffect } from 'react';
import config from '@config';
import { uploadFileApi } from '@services/SiteModule';
import '../../SiteModules.less';

export default ({ drawerState, setDrawerState, currentModule, updateModuleSettings }) => {
    const [form] = Form.useForm();
    // 使用 useWatch 响应式订阅 org_groups 的完整嵌套数据，避免在渲染中直接调用 getFieldValue 拿不到最新值
    const orgGroups = Form.useWatch('org_groups', { form, preserve: true });

    const closeDrawer = () => setDrawerState({ ...drawerState, visible: false });

    // 新增模块
    const onFinish = async values => {
        updateModuleSettings({
            ...values,
            id: currentModule.id,
            data: JSON.stringify({ org_groups: values.org_groups }),
        });
    };

    // 上传图片
    const beforeUpload = file => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg';
        if (!isJpgOrPng) {
            message.error('只能上传 jpg/png/jpeg 格式');
        }
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isLt5M) {
            message.error('图片大小不超过5MB');
        }
        return isJpgOrPng && isLt5M;
    };

    // 上传文件路径 - 前缀
    const getFileUrl = url => {
        // 防御：后端返回结构不一致或历史脏数据可能传入对象/数组/undefined
        if (typeof url !== 'string' || !url) {
            return null;
        }
        if (url.includes('https')) {
            return url;
        }
        return config.OSS_PREFIX + url;
    };

    // 上传图片
    const upload = async (value, index, subIndex) => {
        const formData = new FormData();
        formData.append('file', value.file);
        formData.append('type', 14);
        const res = await uploadFileApi(formData);
        if (res && res.status_code === 200) {
            const logo = res.data;
            const currentValue = form.getFieldValue('org_groups') || [];
            const newValue = [...currentValue];
            const group = { ...(newValue[index] || {}) };
            const organizations = [...(group.organizations || [])];
            organizations[subIndex] = { ...(organizations[subIndex] || {}), logo };
            group.organizations = organizations;
            newValue[index] = group;
            form.setFieldValue('org_groups', newValue);
        }
    };

    useEffect(() => {
        if (currentModule && drawerState?.visible) {
            let org_groups = [];
            if (currentModule.data) {
                const data = JSON.parse(currentModule.data);
                org_groups = data.org_groups || [];
            }

            form.setFieldsValue({
                displayTitle: currentModule.displayTitle,
                displayTitleEn: currentModule.displayTitleEn,
                hiddenWeb: currentModule.hiddenWeb,
                hiddenH5: currentModule.hiddenH5,
                status: currentModule.status,
                path: currentModule.path,
                org_groups,
            });
        }
    }, [currentModule]);

    return (
        <Drawer
            closable={{ placement: 'end' }}
            title={`模块配置：${currentModule?.displayTitle}`}
            className="applog-record-drawer"
            size="100%"
            placement="bottom"
            push={false}
            open={drawerState?.moduleType === 2 && drawerState.visible}
            onClose={closeDrawer}
            footer={
                <div className="custom-drawer-footer" style={{ textAlign: 'right' }}>
                    <Space>
                        <Button onClick={closeDrawer}>取消</Button>
                        <Button type="primary" form="OrganizationModuleForm" htmlType="submit">
                            确定
                        </Button>
                    </Space>
                </div>
            }
        >
            <SiteModuleDrawerOperationLogExtra siteModuleId={currentModule?.id} />
            <Form name="OrganizationModuleForm" form={form} {...fullWidthPageFormItemLayout} onFinish={onFinish}>
                <Form.Item name="displayTitle" label="显示标题" rules={[{ required: true, message: '显示标题不能为空' }]}>
                    <Input placeholder="请输入模块显示标题" />
                </Form.Item>

                <Form.Item name="displayTitleEn" label="英文显示标题">
                    <Input placeholder="请输入模块英文显示标题" />
                </Form.Item>

                <Form.Item
                    name="path"
                    label="访问路径"
                    rules={[
                        { required: true, message: '访问路径不能为空' },
                        { pattern: /^[a-z\d_]{2,20}$/, message: '访问路径不符合格式要求' },
                    ]}
                    help={
                        <>
                            填写访问该模块的访问路径，如会议简介访问路径 <b>introduction</b>
                            <br />
                            格式合求：小写字母、数字或下划线（_），限2-20个字符
                        </>
                    }
                >
                    <Input placeholder="请输入模块访问路径" minLength={2} maxLength={20} showCount disabled={currentModule?.moduleType <= 10} />
                </Form.Item>
                {/* 外层仅用于 label 布局展示，不持有字段（避免与内部 Form.List 同名冲突） */}
                <Form.Item label="机构分组">
                    <Form.List name="org_groups">
                        {(fields, { add, remove, move }) => (
                            <>
                                <Form.Item>
                                    <Button
                                        onClick={() => {
                                            add();
                                        }}
                                    >
                                        <i className="bi bi-plus-circle"></i>
                                        添加机构分组
                                    </Button>
                                </Form.Item>
                                {fields.map(({ key, name, ...restField }, index) => (
                                    <div key={key} className="exhibition-add">
                                        <Space
                                            key={key}
                                            style={{
                                                display: 'flex',
                                            }}
                                            align="center"
                                        >
                                            <div style={{ paddingRight: '20px' }}>
                                                <Form.Item
                                                    label="机构分组"
                                                    name={[name, 'group_name']}
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: '请输入机构名称',
                                                        },
                                                    ]}
                                                >
                                                    <Input style={{ width: 300 }} placeholder="请输入机构名称" maxLength={100} />
                                                </Form.Item>
                                                <Form.List name={[name, 'organizations']}>
                                                    {(organizations, { add, remove, move }) => (
                                                        <>
                                                            <Form.Item>
                                                                <Button
                                                                    onClick={() => {
                                                                        add();
                                                                    }}
                                                                >
                                                                    <i className="bi bi-plus-circle"></i>
                                                                    添加机构
                                                                </Button>
                                                            </Form.Item>
                                                            {organizations.map(({ key, name, ...restField }, subIndex) => (
                                                                <div key={key} className="exhibition-add">
                                                                    <Space
                                                                        key={key}
                                                                        style={{
                                                                            display: 'flex',
                                                                        }}
                                                                        align="center"
                                                                    >
                                                                        <div style={{ paddingRight: '20px' }}>
                                                                            <Form.Item
                                                                                label="机构名称"
                                                                                name={[name, 'name']}
                                                                                rules={[
                                                                                    {
                                                                                        required: true,
                                                                                        message: '请输入机构名称',
                                                                                    },
                                                                                ]}
                                                                            >
                                                                                <Input style={{ width: 300 }} placeholder="请输入机构名称" maxLength={100} />
                                                                            </Form.Item>
                                                                            {/* logo 的实际值由隐藏的 Form.Item 注册，展示部分不带 name 避免多子元素反模式 */}
                                                                            <Form.Item name={[name, 'logo']} hidden>
                                                                                <Input />
                                                                            </Form.Item>
                                                                            <Form.Item
                                                                                label="机构logo"
                                                                                className="organizationUploadWrap"
                                                                                help={
                                                                                    <Typography.Text type="secondary" style={{ display: 'block', marginBottom: 10 }}>
                                                                                        LOGO尺寸336×120px，支持JPG/PNG格式，文件大小不超过5MB
                                                                                    </Typography.Text>
                                                                                }
                                                                            >
                                                                                {orgGroups?.[index]?.organizations?.[subIndex]?.logo ? (
                                                                                    <div className="imageWarp">
                                                                                        <Image width={102} src={getFileUrl(orgGroups[index].organizations[subIndex].logo)} alt="" />
                                                                                    </div>
                                                                                ) : null}
                                                                                <Upload customRequest={e => upload(e, index, subIndex)} listType="picture-card" fileList={[]} showUploadList={{ showRemoveIcon: false }} beforeUpload={beforeUpload} accept="image/jpeg, image/png, image/jpg">
                                                                                    <div>
                                                                                        <i className="bi bi-plus"></i>
                                                                                        <div
                                                                                            style={{
                                                                                                marginTop: 8,
                                                                                            }}
                                                                                        >
                                                                                            {orgGroups?.[index]?.organizations?.[subIndex]?.logo ? '更改图片' : '上传图片'}
                                                                                        </div>
                                                                                    </div>
                                                                                </Upload>
                                                                            </Form.Item>
                                                                            <Form.Item label="机构简介" name={[name, 'intro']}>
                                                                                <Input.TextArea style={{ width: 300 }} placeholder="请输入机构简介" rows={4} />
                                                                            </Form.Item>
                                                                        </div>

                                                                        <span className="anticon" onClick={() => remove(name)}>
                                                                            <i className="bi bi-dash-circle"></i>
                                                                        </span>
                                                                        {subIndex !== 0 ? (
                                                                            <span
                                                                                className="anticon"
                                                                                onClick={() => {
                                                                                    move(subIndex, subIndex - 1);
                                                                                }}
                                                                            >
                                                                                <i className="bi bi-arrow-up"></i>
                                                                            </span>
                                                                        ) : null}
                                                                        {subIndex !== organizations.length - 1 ? (
                                                                            <span
                                                                                className="anticon"
                                                                                onClick={() => {
                                                                                    move(subIndex, subIndex + 1);
                                                                                }}
                                                                            >
                                                                                <i className="bi bi-arrow-down"></i>
                                                                            </span>
                                                                        ) : null}
                                                                    </Space>
                                                                </div>
                                                            ))}
                                                        </>
                                                    )}
                                                </Form.List>
                                            </div>

                                            <span
                                                className="anticon"
                                                onClick={() => {
                                                    remove(name);
                                                }}
                                            >
                                                <i className="bi bi-dash-circle"></i>
                                            </span>
                                            {index !== 0 ? (
                                                <span
                                                    className="anticon"
                                                    onClick={() => {
                                                        move(index, index - 1);
                                                    }}
                                                >
                                                    <i className="bi bi-arrow-up"></i>
                                                </span>
                                            ) : null}
                                            {index !== fields.length - 1 ? (
                                                <span
                                                    className="anticon"
                                                    onClick={() => {
                                                        move(index, index + 1);
                                                    }}
                                                >
                                                    <i className="bi bi-arrow-down"></i>
                                                </span>
                                            ) : null}
                                        </Space>
                                    </div>
                                ))}
                            </>
                        )}
                    </Form.List>
                </Form.Item>
                <Form.Item
                    name="status"
                    label="导航状态"
                    rules={[
                        {
                            required: true,
                        },
                    ]}
                >
                    <Radio.Group>
                        <Radio value={1}>开启</Radio>
                        <Radio value={2}>敬请期待</Radio>
                    </Radio.Group>
                </Form.Item>
                <Form.Item name="hiddenWeb" label="Web端是否隐藏" rules={[{ required: true }]}>
                    <Radio.Group>
                        <Radio value={0}>显示</Radio>
                        <Radio value={1}>隐藏</Radio>
                    </Radio.Group>
                </Form.Item>

                <Form.Item name="hiddenH5" label="H5端是否隐藏" rules={[{ required: true }]}>
                    <Radio.Group>
                        <Radio value={0}>显示</Radio>
                        <Radio value={1}>隐藏</Radio>
                    </Radio.Group>
                </Form.Item>
            </Form>
        </Drawer>
    );
};
